import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import PaymentHistoryListLayer from '../components/PaymentHistoryListLayer'

const PaymentHistoryPage = () => {
    return (
        <MasterLayout>
            <PaymentHistoryListLayer />
        </MasterLayout>
    )
}

export default PaymentHistoryPage
